import { n as c } from "./Logger-CmiOOsKC.js";
import "./boxcollider-DfK5pGI3.js";
import "./textBody-DYKq_GsW.js";
function a(e) {
  return e.name.endsWith("__collider") || e.name.endsWith("__selection") || e.name.endsWith("__textBody");
}
function _(e, r) {
  r.length !== 0 && c.debug(`[${e}] excluded ${r.length} editor helper mesh(es) from the export by name suffix: ${r.map((t) => t.name).join(", ")}. A user mesh named this way is dropped too.`);
}
function E(e, r) {
  const t = e.traceScene, o = typeof t?.findSceneObjectByTransform == "function" ? t.findSceneObjectByTransform.bind(t) : null, i = [], f = (n) => {
    if (o) {
      const s = o(n);
      if (s && s !== e) return;
    }
    if (a(n)) {
      r?.push(n);
      return;
    }
    i.push(n);
    for (const s of n.getChildren()) f(s);
  };
  for (const n of e.transform.getChildren()) f(n);
  return i;
}
export {
  E as n,
  _ as r,
  a as t
};

//# sourceMappingURL=exportFilters-BQ5JaJJo.js.map